module.exports = __webpack_public_path__ + "static/img/footer.dcd02581.png";